'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'

interface ActiveLinkProps {
  href: string
  children: ReactNode
  className?: string
  activeClassName?: string
}

/**
 * Client component that highlights when the current path matches
 */
export const ActiveLink = ({
  href,
  children,
  className = '',
  activeClassName = 'text-vi-red',
}: ActiveLinkProps) => {
  const pathname = usePathname()

  // Normalize paths by removing trailing slashes (except root)
  const normalizePath = (path: string) =>
    path === '/' ? '/' : path.replace(/\/$/, '')
  const normalizedHref = normalizePath(href)
  const normalizedPathname = pathname ? normalizePath(pathname) : ''

  // Match exact path only (handles trailing slash differences)
  const isActive = normalizedPathname === normalizedHref

  return (
    <Link
      href={href}
      prefetch={false}
      className={`${className} ${isActive ? activeClassName : ''}`}
    >
      {children}
    </Link>
  )
}
